import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Autenticacao } from "../../../services/Autenticacao";
import { removeDigitos } from "../../../utils/masks";
import { IAutenticacaoForm, IDecodedToken } from "../../../types/autenticacao";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useContextSite } from "../../../context/Context";
import { useCallback, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { Denuncia } from "../../../services/Denuncias";
import { Usuario } from "../../../services/Usuario";

export const useLogin = () => {
  const navigate = useNavigate();
  const { setIsLoad, setTokenContext } = useContextSite();
  const [token, setToken] = useSessionStorage("@token");
  const [sessionUsuario, setSessionUsuario] = useSessionStorage("Usuario");
  const username = process.env.REACT_APP_AUTH_USERNAME;
  const password = process.env.REACT_APP_AUTH_PASSWORD;

  const auth_denuncia = useCallback(() => {
    Denuncia.auth({ username, password })
      .then(({ data: { token } }) => {
        sessionStorage.setItem("@auth_token_denuncia", JSON.stringify(token));
      })
      .catch((error) => {
        // auth secundária em background: não bloqueia nem alerta o login
        console.error("Falha na autenticação de denúncias:", error);
      })
      .finally(() => {
        setIsLoad(false);
      });
  }, [username, password]);

  useEffect(() => {
    if (token) {
      navigate("/relatorio-geral");
    }
  }, []);

  async function onSubmit(data: IAutenticacaoForm) {
    const PAYLOAD: IAutenticacaoForm = {
      ...data,
      cpfCNPJ: removeDigitos(data.cpfCNPJ),
    };

    setIsLoad(true);

    auth_denuncia();

    await Autenticacao.post(PAYLOAD)
      .then(({ data }) => {
        setToken(data.token);
        setTokenContext(data.token);
        return data.token;
      })
      .then((token) => {
        const decoded = jwtDecode<IDecodedToken>(token);
        Usuario.getRecursosByUuid({ uuid: decoded.uuid })
          .then(({ data }) => {
            setSessionUsuario({
              ...decoded,
              recusos: data,
            });
            toast.success("Login efetuado com sucesso!", { autoClose: 1500 });
            setTimeout(() => {
              navigate("/relatorio-geral");
            }, 2000);
          })
          .catch(
            ({
              response: {
                data: { mensagem },
              },
            }) => {
              toast.error(mensagem);
              setTokenContext("");
              sessionStorage.removeItem("@token");
            }
          )
          .finally(() => {
            setIsLoad(false);
          });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
          setTokenContext("");
          sessionStorage.removeItem("@token");
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { onSubmit };
};
